import React, { Component } from 'react';
import AccessDeniedBehavior from '../../services/enums/accessDeniedBehavior';
import Permissions from '../../services/enums/permissions';
import UsersGridContainer from './usersGridContainer';
import authorize from '../authorization/authorize';
import PrivateRouteWrapper from '../router/privateRouteWrapper';


export default class UsersContainer extends Component {

    componentWillMount() {

        this.AuthorizedUsersGridContainer = authorize(
            [Permissions.manageUsers],
            window.location.hash === '#/' ? AccessDeniedBehavior.redirect : AccessDeniedBehavior.displayError,
            '/profile')
            (UsersGridContainer);
    }

    render() {

        return (
            <PrivateRouteWrapper>
                <this.AuthorizedUsersGridContainer />
            </PrivateRouteWrapper>
        );
    }
}